require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./people-luke-fowell.json") })
        }
      }, "path---people-luke-fowell");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---people-luke-fowell!./.cache/json/people-luke-fowell.json
// module id = 1463
// module chunks = 231608221292675